// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"345":"order-page","457":"ap-order-page","992":"reports"}[chunkId] + "." + {"345":"acfde97a","457":"acfde97a","992":"4568973a"}[chunkId] + ".chunk.css";
};